import type React from 'react';
import { useTranslation } from 'react-i18next';
import PageSection from '../../../components/layout/PageSection';
import BookingCalendar from './BookingCalendar';
import type { CaseScheduleEntry } from '../types';

interface CaseCalendarTabProps {
  schedule: CaseScheduleEntry[];
  scheduleLoading: boolean;
  scheduleFilter: string;
  setScheduleFilter: React.Dispatch<React.SetStateAction<string>>;
}

const FILTERS = ['upcoming', 'active', 'all'] as const;

const CaseCalendarTab = ({ schedule, scheduleLoading, scheduleFilter, setScheduleFilter }: CaseCalendarTabProps) => {
  const { t } = useTranslation();

  return (
    <PageSection
      title={t('calendar.rentalAvailability', 'Booking Calendar')}
      description={t('warehouses.cases.calendarDescription', 'Use the calendar view to spot rental pressure, active windows and future reservations.')}
      actions={
        <div className="btn-group" role="group">
          {FILTERS.map((filterValue) => (
            <button
              key={filterValue}
              type="button"
              className={`btn btn-sm ${scheduleFilter === filterValue ? 'btn-primary' : 'btn-outline-secondary'}`}
              onClick={() => setScheduleFilter(filterValue)}
            >
              {filterValue === 'upcoming'
                ? t('warehouses.items.scheduleUpcoming')
                : filterValue === 'active'
                  ? t('warehouses.items.scheduleActive')
                  : t('warehouses.items.scheduleAll')}
            </button>
          ))}
        </div>
      }
      bodyClassName="p-0"
    >
      <BookingCalendar schedule={schedule} loading={scheduleLoading} filter={scheduleFilter} />
    </PageSection>
  );
};

export default CaseCalendarTab;
